// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/dme.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/dme/dme.js';

mount([g0]);
